import type { BomVersion } from "@/api/bom";

type Line = BomVersion["lines"][number];

/** O líquido de um ano: o do contrato dividido pelo período da linha. */
export function annualNet(line: Pick<Line, "net_contract_value" | "period_months">): number | null {
  if (line.net_contract_value == null) return null;
  const period = line.period_months || 12;
  return (line.net_contract_value * 12) / period;
}

/** A lista de um ano: a do contrato dividida pelo período da linha. */
export function annualList(
  line: Pick<Line, "total_list_price" | "period_months">,
): number | null {
  if (line.total_list_price == null) return null;
  const period = line.period_months || 12;
  return (line.total_list_price * 12) / period;
}
